import React, { Component } from 'react';
import { connect } from 'react-redux';
import _, { isEmpty, get } from 'lodash';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';

import Input from '../../../../components/FormElements/Input';
import Select from '../../../../components/FormElements/Select';
import ModalConfirmation from '../../../../components/ModalConfirmation';

import { formFields, confirmationMessage, successfullyMessage, attributeAlreadyExistsMessage, emptyAttributeMessage } from './constant';
import { handleFieldError, initializeForm, handleError } from '../../../../utils/form-validation';
import { addAdminVariableAction, getConfigurationDataAction, getPlatformListAction } from '../../../../actions';
import { removeSpaces } from '../../../../selectors';

import AddAttributeValues from '../AddAttributeValues';

const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

class AddVariable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      touched: {},
      errors: {},
      submited: false,
      confirmationOpen: false,
      confirmationInfo: '',
      attributeValuesList: [],
    };
  }

  componentWillMount() {
    const { match: { params: { id } } } = this.props;
    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.this.props;
      history.push(routes.preSignIn);
    }

    this.formInitialize();
    this.getPlatformList();

    if (id) {
      this.editId(id);
    }
  }

  async formInitialize() {
    // const { match: { params: { id = '' } }, configurationList } = this.props;
    // if (id) {
    //   const { form } = this.state;
    //   let formN = {
    //     attrName: form.attrName, attributeValues: form.attributeValues
    //   };

    //   this.setState({ form: formN });

    // } else {
    const { form, errors } = initializeForm(formFields);
    form.attributeValues = [{
      key: '',
      value: ''
    }];
    this.setState({ form, errors });
    // }
  }

  async getPlatformList() {
    const { getPlatformListAction, tenantId, authToken, userId, platformListAll } = this.props;
    await getPlatformListAction({ tenantId, authToken, userId });
  }


  editId = async (id) => {

    const { getConfigurationDataAction, tenantId, authToken, userId } = this.props;
    const { form } = this.state;
    let respone = await getConfigurationDataAction({ tenantId, authToken, userId });
    if (respone && respone.responseCode && respone.responseCode.status === "Success" && respone.responseList && respone.responseList.length) {
      let variableObj = respone.responseList.find((a) => a.aId == id);
      if (variableObj) {
        form.platformId = variableObj.platformId;
        form.attrName = variableObj.attrName;
        form.attributeValues = variableObj.attributeValues;
        let attributeValuesList = (variableObj.attributeValues || []).map((data, index) => ({ key: data.key, value: data.value, id: index }));
        this.setState({ form, attributeValuesList });
      }
    }
  };

  // handleChange = (e) => {
  //   const { form } = this.state;
  //   form[e.target.name] = e.target.value.toUpperCase();
  //   this.setState({ form });
  // };

  handleChange = (e) => {
    const { form } = this.state;
    if (e.target.name == 'attrName')
      form[e.target.name] = e.target.value.toUpperCase();
    if (e.target.name == "replaceValue") {
      form[e.target.name] = e.target.checked;
    }
    else
      form[e.target.name] = e.target.value;
    this.setState({ form });
  };

  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };


  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    const { confirmationOpen } = this.state;
    if (success && info.action.type === 'Confirmation') {
      this.submitForm();
    } else if (info.action.type === 'alert') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.variable.name}`);
      });
      return;
    }
    this.setState({ confirmationOpen: false });
  };


  // async submitForm() {
  //   const { match: { params: { id } }, addAdminAttrNameVariableAction, addAdminAttributeValuesVariableAction, tenantId, authToken, userId } = this.props;
  //   const { form } = this.state;
  //   let addParams = { action: 'create' };
  //   let response;

  //   let payload = this.attrNameGeneratePayload(form, id);
  //   if (id) {
  //     addParams = { action: 'update' };
  //   }

  //   if (!id) {
  //     const { responeCode: { msg = '', status = '' } } = await (addAdminAttrNameVariableAction({ tenantId, authToken, userId, payload, addParams }) || '');
  //     if (status === 'Success') {
  //       this.setState({ confirmationOpen: false }, () => {
  //         this.toggleModal(successfullyMessage);
  //       });
  //       return;
  //     } else {
  //       const info = { action: { confirmationMessage: msg, type: 'error' } };
  //       this.toggleModal(info);
  //     }
  //   }
  //   if (id) {
  //     const { attributeValuesList } = this.state;
  //     // let { EditAttributeValues } = this.attributeValuesGeneratePayload(attributeValuesList, id);
  //     let { EditAttributeValues } = this.attributeValuesGeneratePayload(form.attributeValues, id);
  //     // if (AddAttributeValues.attributeValues && AddAttributeValues.attributeValues.length) {
  //     //   await addAdminAttributeValuesVariableAction({ tenantId, authToken, userId, payload: AddAttributeValues, addParams: { action: 'create' } });
  //     // }

  //     if (EditAttributeValues.attributeValues && EditAttributeValues.attributeValues.length) {
  //       const { responeCode: { msg = '', status = '' } } = await addAdminAttributeValuesVariableAction({ tenantId, authToken, userId, payload: EditAttributeValues, addParams: { action: 'update' } });
  //       if (status === 'Success') {
  //         this.setState({ confirmationOpen: false }, () => {
  //           this.toggleModal(successfullyMessage);
  //         });
  //         return;
  //       } else {
  //         const info = { action: { confirmationMessage: msg, type: 'error' } };
  //         this.toggleModal(info);
  //       }
  //     } else {
  //       this.setState({ confirmationOpen: false }, () => {
  //         this.toggleModal(successfullyMessage);
  //       });
  //     }
  //   }

  //   this.formInitialize();
  // }


  async submitForm() {
    const { match: { params: { id } }, addAdminVariableAction, tenantId, authToken, userId } = this.props;
    const { form } = this.state;
    let addParams = { action: 'create' };
    if (id) {
      addParams = { action: 'update' };
      form.attributeValues = form.attributeValues.filter(item => item.value !== '');
    }
    else {
      form.attributeValues = form.attributeValues.filter(item => item.value !== '').map(item => ({ value: item.value }))
    }
    let payload = form;
    const { responseCode: { msg = '', status = '' } } = await (addAdminVariableAction({ tenantId, authToken, userId, payload, addParams }) || '');
    if (status === 'Success') {
      this.setState({ confirmationOpen: false }, () => {
        this.toggleModal(successfullyMessage);
      });
      return;
    } else {
      const info = { action: { confirmationMessage: msg, type: 'error' } };
      this.toggleModal(info);
    }

    // if (id) {

    //   let { EditAttributeValues } = this.attributeValuesGeneratePayload(form.attributeValues, id);

    //   EditAttributeValues.attributeValues = EditAttributeValues.attributeValues.filter(item => item.value !== '');

    //   if (EditAttributeValues.attributeValues && EditAttributeValues.attributeValues.length) {
    //     const { responeCode: { msg = '', status = '' } } = await addAdminVariableAction({ tenantId, authToken, userId, payload: EditAttributeValues, addParams: { action: 'update' } });
    //     if (status === 'Success') {
    //       this.setState({ confirmationOpen: false }, () => {
    //         this.toggleModal(successfullyMessage);
    //       });
    //       return;
    //     } else {
    //       const info = { action: { confirmationMessage: msg, type: 'error' } };
    //       this.toggleModal(info);
    //     }
    //   } else {
    //     this.setState({ confirmationOpen: false }, () => {
    //       this.toggleModal(successfullyMessage);
    //     });
    //   }
    // }

    this.formInitialize();
  }

  attributeValuesGeneratePayload(attributeValuesList, id) {
    let EditAttributeValues = {};
    let EditAttributeValuesList = [];
    const { form } = this.state;

    attributeValuesList.forEach((item) => {
      if (item.key) {
        EditAttributeValuesList.push({ key: item.key, value: item.value });
      } else {
        EditAttributeValuesList.push({ key: '', value: item.value });
      }
    });

    EditAttributeValues.attributeValues = EditAttributeValuesList;
    EditAttributeValues.aId = id;
    EditAttributeValues.platformId = form.platformId;
    // EditAttributeValues.createdBy = 'Admin';

    return { EditAttributeValues };
  }

  // attrNameGeneratePayload({ attrName }, id) {
  //   return { attrName: removeSpaces(attrName), aId: id ? id : undefined };
  // }


  handleSubmit = (e) => {
    e.preventDefault();

    const { form } = this.state;
    const { configurationList, match: { params: { id } } } = this.props;
    let { errors, valid } = handleError(form, formFields);
    console.log(form)
    if (valid) {
      // Todo confirmation user

      let match = '';
      if (id) {
        match = configurationList.find((item) => item.aId != id && (item.attrName == form.attrName));
      } else {
        match = configurationList.find((item) => item.attrName == form.attrName);
      }

      let emptyAttribute = form.attributeValues.some(item => item.value !== '');
      if (form.replaceValue == false) {
        if (match) {
          this.toggleModal(attributeAlreadyExistsMessage);
          return;
        }
      }
      if (!emptyAttribute) {
        this.toggleModal(emptyAttributeMessage);
        return;
      }

      this.toggleModal(confirmationMessage);
    } else {

      this.setState({ errors: errors, submited: true });
    }
  };

  reset = () => {
    this.formInitialize();
  };

  handleAttributeValues = (data) => {
    const { attributeValuesList } = this.state;
    if (data.id || data.id === 0) {
      let attributeValue = attributeValuesList.find((item) => item.id == data.id);
      if (attributeValue) {
        attributeValue.value = removeSpaces(data.attributeValues);
      }
    } else {
      const ids = attributeValuesList.map((item) => parseInt(item.id));
      let id = ids.length ? Math.max(...ids) + 1 : 1;
      // attributeValuesList.push({ value: data.attributeValues(data.attributeValues), id: id });
      attributeValuesList.push({ value: data.attributeValues, id: id });
    }
  };

  onAttributeValueChange = (e, index) => {
    let { form } = this.state;
    form.attributeValues[index].value = e.target.value;
    this.setState({ form });
  };

  addAttributeValues = () => {
    let { form: { attributeValues }, form } = this.state;

    attributeValues.push({
      key: '',
      value: ''
    });

    this.setState({ form });
  };

  renderAttributeValue = (attributeValues) => {
    let attributeValueData = [];
    const { form } = this.state;
    attributeValueData = _.map(attributeValues, (item, index) => {
      return (
        <div className="form-group row" key={index}>
          <label className={'col-form-label col-sm-4'}>Value {index + 1}</label>
          <div className={'col-md-7'}>
            <input
              className={"form-control"}
              onChange={(e) => this.onAttributeValueChange(e, index)}
              type={'text'}
              value={form.attributeValues[index].value}
            />
          </div>
        </div>
      );
    });
    return attributeValueData;
  };


  render() {
    const { confirmationOpen, confirmationInfo, submited, errors, touched, form, attributeValuesList } = this.state;
    const { match: { params: { id = '' } }, configurationList, platformListAll } = this.props;
    const platformList = _.map(platformListAll, (item) => ({ id: item.id, name: item.name }));

    return (
      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}
        <div className="main-panel ion">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row justify-content-center">
              <div className="col-md-6 grid-margin">
                <Card>
                  {/* <Select
                    onChange={this.handleChange}
                    onBlur={this.handleTouch}
                    value={form[formFields.platformId.key]}
                    setting={formFields[formFields.platformId.key]}
                    error={errors[formFields.platformId.key]}
                    submited={submited}
                    touched={touched[formFields.platformId.key]}
                    options={platformList}
                  /> */}
                  <Input
                    onChange={this.handleChange}
                    onBlur={this.handleTouch}
                    disabled={id ? true : false}
                    value={form[formFields.attrName.key]}
                    setting={formFields[formFields.attrName.key]}
                    error={errors[formFields.attrName.key]}
                    submited={submited}
                    touched={touched[formFields.attrName.key]}
                  /><br />

                  {this.renderAttributeValue(form.attributeValues)}

                  <div className="row form-group">
                    <div className="ml-auto">
                      <button onClick={this.addAttributeValues} className="btn btn-primary d-inline-flex">
                        <i className="mdi mdi-plus"></i> Add
                      </button>
                    </div>
                  </div>

                  {/* {
                    !id && <div className="row">
                      <div className={'col-sm-4'}></div>
                      <div className={'col-md-8'}>
                        <div className="form-check">
                          <input name='replaceValue' className="form-check-input" type="checkbox" id="replaceValue" onChange={this.handleChange} />
                          <label className="form-check-label" htmlFor="replaceValue">
                            Replace Value
                          </label>
                        </div>
                      </div>
                    </div>
                  } */}

                  {/* {
                    id && (<AddAttributeValues
                      attributeValuesList={attributeValuesList}
                      // handleDeleteAttribute={(attributeValuesList) => { this.setState({ attributeValuesList }) }}
                      handleAttributeValues={this.handleAttributeValues}
                    />)
                  }<br /> */}
                  <div className="form-group row">
                    <div className="col-sm-12">
                      <center>
                        <button type="submit" onClick={this.handleSubmit} className="btn btn-primary">Save</button>
                        {' '}
                        {/* <button type="button" onClick={this.reset} className="btn btn-secondary">Reset</button> */}
                        {' '}
                        <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.variable.name}`}><button type="button" className="btn btn-secondary">Cancel</button></Link>
                      </center>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div >
      </>
    );
  }

}


export default connect(
  (state) => ({
    configurationList: get(state, 'app.configurationData.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
    platformListAll: get(state, 'app.platformListAll.responseList', '')
  }), {
  // addAdminAttrNameVariableAction,
  // addAdminAttributeValuesVariableAction,
  getConfigurationDataAction,
  addAdminVariableAction,
  getPlatformListAction
}
)(AddVariable);

AddVariable.propTypes = {
  configurationList: PropTypes.array,
  tenantId: PropTypes.number,
  userId: PropTypes.number,
  authToken: PropTypes.string,
};
